export default [
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Currency',
    },
    cell: {
      type: 'slot',
      name: 'currency',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Pay In',
    },
    cell: {
      type: 'slot',
      name: 'payin',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Pay Out',
    },
    cell: {
      type: 'slot',
      name: 'payout',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Total',
    },
    cell: {
      type: 'slot',
      name: 'total',
    },
  },
];
